import React from "react"

//components
import { TextInputWithLabelAndPasswordToggle } from "thrive-components";
import PasswordValidationIndicators from "./PasswordValidationIndicators/PasswordValidationIndicators";

//interfaces
import { IPasswordInput } from "../../../interfaces/FormInputs";


const Password = ({
    showError,
    setPassword,
    password,
    validateField,
    validateCases,
    validateNumber,
    validateSpecialChar,
    validateLength
}: IPasswordInput) => { 
    return (
        <>
            <div className={`${showError ? "error-styling" : ""}`}>
                <TextInputWithLabelAndPasswordToggle
                    id={"create-password"}
                    label={"Password"} 
                    isPassword={true}
                    setValue={setPassword} 
                    defaultValue={password}
                    placeholder={""}        
                    onBlur={validateField}                
                />  
            </div>

            <PasswordValidationIndicators
                validateCases={validateCases} 
                validateNumber={validateNumber} 
                validateSpecialChar={validateSpecialChar} 
                validateLength={validateLength}
            />
        </>
    )
}

export default Password